<template>
  <div class="card-content">
    <form @submit.prevent="buscar">
      <!-- Campos de filtro -->
      <div class="columns is-multiline is-variable is-1-mobile">
        <!-- Nome -->
        <div class="column is-full-mobile is-one-quarter-desktop">
          <b-field label="Nome">
            <b-input
              v-model="filtro.nome"
              placeholder="Digite o Nome"
              @input="atualizarBusca"
            />
          </b-field>
        </div>
        <!-- CPF -->
        <div class="column is-full-mobile is-one-quarter-desktop">
          <b-field label="Empresa">
            <b-input
              v-model="filtro.nomeEmpresa"
              placeholder="Nome da Empresa"
              @input="atualizarBusca"
            />
          </b-field>
        </div>
        <div class="column is-full-mobile is-one-quarter-desktop">
          <b-field label="Tipo de Acesso">
            <b-select
              v-model="filtro.tipoAcessoDispositivo"
              placeholder="Tipo de Acesso"
              expanded
              @input="atualizarBusca"
            >
              <option :value="null">Todos</option>
              <option value="PESSOAL">Pessoal</option>
              <option value="CORPORATIVO">Corporativo</option>
            </b-select>
          </b-field>
        </div>

        <div class="column is-full-mobile is-one-quarter-desktop">
          <b-field label="Status">
            <b-select
              v-model="filtro.status"
              placeholder="Status"
              expanded
              @input="atualizarBusca"
            >
              <option :value="null">Todos</option>
              <option value="PENDENTE">PENDENTE</option>
              <option value="DOCUMENTACAO_PENDENTE">
                PENDENTE DOCUMENTAÇÃO
              </option>
              <option value="BLOQUEADO">BLOQUEDO</option>
              <option value="APROVADO">APROVADO</option>
              <option value="RECUSADO">RECUSADO</option>
              <option value="DOCUMENTACAO_EXPIRADA">
                DOCUMENTAÇÃO EXPIRADA
              </option>
            </b-select>
          </b-field>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "FilterDispositivos",
  props: {
    initialFiltro: {
      type: Object,
      default: () => ({
        nome: null,
        tipoAcessoDipositivo: null,
        tipoDispositivo: null,
        nomeEmpresa: null,
        marca: null,
        status: null,
        modelo: null,
        cor: null,
      }),
    },
  },
  data() {
    return {
      filtro: { ...this.initialFiltro },
      filtrosAvancadosVisiveis: false,
      timer: null,
    };
  },
  methods: {
    atualizarBusca() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.buscar(), 500);
    },
    buscar() {
      this.$emit("filtrar", this.filtro);
    },
  },
});
</script>
